// extracted by mini-css-extract-plugin
export default {"page":"page-manage-uploaded-documents_page__OPtd2","content":"page-manage-uploaded-documents_content__I+Ds0"};